import styled from "styled-components";

const CardWidgetStyled = styled.img`
  max-width: 54px;
  border-radius: 20px;
`;

export default CardWidgetStyled;